import Repository from "./repository"

export default {
    /**
     * 入力されたサービス内容の妥当性チェック
     * @param {*} params 入力されたサービス内容
     * @returns response
     */
    getServiceDetailCheck(params) {
        return Repository.post('/f201-first-order/serviceDetailCheck', params)
    },
    /**
     * 入力されたお客様情報の妥当性チェック
     * @param {*} params 入力されたお客様情報
     * @returns response
     */
    getCustomerDetailCheck(params) {
        return Repository.post('/api/f201-first-order/customerDetailCheck', params)
    },
    /**
     * 入力されたお申し込み内容をDBに登録する
     * @param {*} params 入力されたお申し込み内容
     * @returns response
     */
    add (params) {
        return Repository.post('/api/f201-first-order/add', params)
    },
}